module.exports = __webpack_public_path__ + "assets/img/IMG020.5425f988.png";